import createIcon from '../../createIcon';

/**
 * @component @name FourkPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMC41IDEzLjVIOS41VjE1SDhWMTMuNUg1VjlINi41VjEySDhWOUg5LjVWMTJIMTAuNVYxMy41Wk0xNiAxNUgxNC4yNUwxMi41IDEyLjc1VjE1SDExVjlIMTIuNVYxMS4yNUwxNC4yNSA5SDE2TDEzLjc1IDEyTDE2IDE1Wk0yMCAxMi41SDE4LjVWMTRIMTcuNVYxMi41SDE2VjExLjVIMTcuNVYxMEgxOC41VjExLjVIMjBWMTIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FourkPlus = createIcon('FourkPlus', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.5 13.5H9.5V15H8V13.5H5V9H6.5V12H8V9H9.5V12H10.5V13.5ZM16 15H14.25L12.5 12.75V15H11V9H12.5V11.25L14.25 9H16L13.75 12L16 15ZM20 12.5H18.5V14H17.5V12.5H16V11.5H17.5V10H18.5V11.5H20V12.5Z',
      key: '9h4lwh',
    },
  ],
]);

export default FourkPlus;
